var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-return",attrs:{"tag":"a"},on:{"click":function($event){_vm.hasHistory() 
  ? _vm.$router.go(-1) 
  : _vm.$router.push('/')}}},[_vm._v(" voltar ")])
}
var staticRenderFns = []

export { render, staticRenderFns }